import { getFileList, createFile, createFolder, copyFolder, updateUserFile, updateFolder, deleteUserFile, deleteFolder, moveFile, moveFolder, copyUserFile } from '@/api/files'
import { ElMessage } from 'element-plus'

export default {
  namespaced: true,
  
  state: {
    files: [],
    currentPath: [],
    loading: false,
    total: 0,
    /** 仅拉取当前用户创建的文件/文件夹（需 view_all_*；管理员「我的」）。
     *  默认 true：进入文件页先看自己的文件，管理员/超管再切到「全部文件」。 */
    listMineOnly: true
  },

  mutations: {
    SET_FILES(state, files) {
      state.files = files
    },
    SET_CURRENT_PATH(state, path) {
      state.currentPath = path
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_TOTAL(state, total) {
      state.total = total
    },
    SET_LIST_MINE_ONLY(state, val) {
      state.listMineOnly = !!val
    }
  },

  actions: {
    async fetchFiles({ commit, state }, { parent_id = null, type = 'document', mine } = {}) {
      const mineFlag = mine !== undefined ? !!mine : state.listMineOnly
      console.log('开始获取文件列表, parent_id:', parent_id, 'type:', type, 'mine:', mineFlag)
      commit('SET_LOADING', true)
      try {
        const files = await getFileList({
          folder_id: parent_id,
          type: type,
          mine: mineFlag
        })
        console.log('获取到的文件列表:', files)
        const fileArray = Array.isArray(files) ? files : []
        console.log('设置文件列表，数量:', fileArray.length)
        commit('SET_FILES', fileArray)
        if (parent_id === null) {
          commit('SET_CURRENT_PATH', [])
        }
      } catch (error) {
        console.error('获取文件列表失败:', error)
        // 即使失败也设置为空数组，避免显示空白
        commit('SET_FILES', [])
        ElMessage.error('获取文件列表失败: ' + (error.message || '未知错误'))
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // eslint-disable-next-line no-unused-vars
    async createFile(_context, data) {
      try {
        await createFile(data)
        ElMessage.success('创建成功')
        // 不在这里调用 fetchFiles，由调用方负责刷新正确的目录
      } catch (error) {
        ElMessage.error('创建失败')
        throw error
      }
    },

    // eslint-disable-next-line no-unused-vars
    async createFolder(_context, data) {
      try {
        await createFolder(data)
        ElMessage.success('文件夹创建成功')
        // 不在这里调用 fetchFiles，由调用方负责刷新正确的目录
      } catch (error) {
        ElMessage.error('文件夹创建失败')
        throw error
      }
    },

    // eslint-disable-next-line no-unused-vars
    async copyFolder(_context, { id, target_parent_id } = {}) {
      if (!id) throw new Error('缺少文件夹ID')
      try {
        await copyFolder(id, { target_parent_id })
        ElMessage.success('复制成功')
      } catch (error) {
        ElMessage.error('复制失败')
        throw error
      }
    },

    // eslint-disable-next-line no-unused-vars
    async copyFile(_context, { id, target_folder_id } = {}) {
      if (!id) throw new Error('缺少文件ID')
      try {
        await copyUserFile(id, { target_folder_id })
        ElMessage.success('复制成功')
      } catch (error) {
        ElMessage.error('复制失败')
        throw error
      }
    },

    // eslint-disable-next-line no-unused-vars
    async updateFile(_context, { id, data, type }) {
      try {
        if (type === 'folder') {
          await updateFolder(id, data)
        } else {
          await updateUserFile(id, data)
        }
        // 不在这里调用 fetchFiles，由调用方负责刷新正确的目录
      } catch (error) {
        ElMessage.error('更新失败')
        throw error
      }
    },

    // eslint-disable-next-line no-unused-vars
    async deleteFile(_context, { id, type, silent = false }) {
      try {
        if (type === 'folder') {
          await deleteFolder(id)
        } else {
          await deleteUserFile(id)
        }
        if (!silent) {
          ElMessage.success('删除成功')
        }
        // 不在这里调用 fetchFiles，由调用方负责刷新正确的目录
      } catch (error) {
        if (!silent) {
          ElMessage.error('删除失败')
        }
        throw error
      }
    },

    // eslint-disable-next-line no-unused-vars
    async moveFile(_context, { id, target_folder_id, folder_id } = {}) {
      try {
        await moveFile(id, { target_folder_id, folder_id })
        ElMessage.success('移动成功')
        // 不在这里调用 fetchFiles，由调用方负责刷新正确的目录
      } catch (error) {
        ElMessage.error('移动失败')
        throw error
      }
    },

    // eslint-disable-next-line no-unused-vars
    async moveFolder(_context, { id, target_parent_id } = {}) {
      try {
        await moveFolder(id, { target_parent_id })
        ElMessage.success('移动成功')
      } catch (error) {
        ElMessage.error('移动失败')
        throw error
      }
    },

    updateCurrentPath({ commit }, path) {
      commit('SET_CURRENT_PATH', path)
    }
  },

  getters: {
    currentPathString: state => state.currentPath.join('/')
  }
} 